export class GuideModel {
  picture = "";
  firstName = "";
  lastName = "";
  age = 0;
  gender = "";
  phoneNumber = "";
  cin = "";
  passportNumber = "";
  clientId = 0;
}
